import { useDispatch, useSelector } from 'react-redux';
import { login, logout } from '../store/features/authSlice';
import { fetcher } from '../helpers/fetcher';
import { apiLinks } from '../config/configApiLinks';

export const useAuth = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);

  const loginUser = async (credentials) => {
    try {
      const userData = await fetcher(apiLinks.login, 'POST', credentials);
      dispatch(login(userData));
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logoutUser = () => {
    dispatch(logout());
  };

  return { authState, loginUser, logoutUser };
};
